'use strict';

import Actions from './actions';
import Modal from '../../../components/modal.jsx';
import React from 'react';
import PropTypes from 'prop-types';
import Store from './store';
import SigninOrRegister from './sign-in-or-register';
import SigninAfterRegister from './sign-in-after-register';
import AutoSigninAfterRegister from './auto-sign-in-after-register';
import Forgot from './forgot.jsx';

const propTypes = {
    accountOnly: PropTypes.bool,
    my: PropTypes.object,
    show: PropTypes.bool,
    cancel: PropTypes.func,
    signinComplete: PropTypes.func,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    autoLoginAfterRegister: PropTypes.bool
};


class SigninOrRegisterFlow extends React.Component {
    constructor(props) {

        super(props);
        this.state = Store.getState();
    }

    componentDidMount() {

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    render() {

        //const show = this.props.signinOrRegister.show;

        let step = '';
        if ( this.state.signinOrRegister.choice_forgot ){
            step = (
                <Forgot {...this.state.forgot} />
            );
        }
        else if (this.state.signinOrRegister.register_success && this.state.signinOrRegister.auto_login) {
            step = (
                <AutoSigninAfterRegister
                    title={this.props.title}
                    signinComplete={this.props.signinComplete}
                    {...this.state.login}/>
            );
        }
        else if (this.state.signinOrRegister.register_success ) {
            step = (
                <SigninAfterRegister
                    title={this.props.title}
                    subTitle={this.props.subTitle}
                    cancel={this.props.cancel}
                    signinComplete={this.props.signinComplete}
                    login={this.state.login}/>
            );
        }
        else { // if ( this.state.signinOrRegister.show ){
            step = (
                <SigninOrRegister
                    accountOnly={this.props.accountOnly}
                    title={this.props.title}
                    subTitle={this.props.subTitle}
                    autoLoginAfterRegister={this.props.autoLoginAfterRegister}
                    cancel={this.props.cancel}
                    signinComplete={this.props.signinComplete}
                    register={this.state.register}
                    signinOrRegister={this.state.signinOrRegister}
                    login={this.state.login} />
            );
        }

        return (
            <Modal
                header="PrioraCare"
                show={this.props.show}
                logo={ require('../../../cdn/media/sunp_60x32_trans.png').default }
                onClose={this.props.cancel}>
                {step}
            </Modal>
        );
    }
}

SigninOrRegisterFlow.propTypes = propTypes;


export default SigninOrRegisterFlow;
